export const PROVINCE_NAMES = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NS: 'Nova Scotia',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon'
}

export const CA_AREA_CODES = [
  { area_code: '204', city: 'Winnipeg', state: 'MB', lat: 49.8951, lng: -97.1384 },
  { area_code: '226', city: 'London', state: 'ON', lat: 42.9849, lng: -81.2453 },
  { area_code: '236', city: 'Vancouver', state: 'BC', lat: 49.2827, lng: -123.1207 },
  { area_code: '249', city: 'Sudbury', state: 'ON', lat: 46.4917, lng: -80.993 },
  { area_code: '250', city: 'Victoria', state: 'BC', lat: 48.4284, lng: -123.3656 },
  { area_code: '263', city: 'Montreal', state: 'QC', lat: 45.5019, lng: -73.5674 },
  { area_code: '289', city: 'Mississauga', state: 'ON', lat: 43.589, lng: -79.6441 },
  { area_code: '306', city: 'Saskatoon', state: 'SK', lat: 52.1579, lng: -106.6702 },
  { area_code: '343', city: 'Ottawa', state: 'ON', lat: 45.4215, lng: -75.6972 },
  { area_code: '354', city: 'Laval', state: 'QC', lat: 45.6066, lng: -73.7124 },
  { area_code: '365', city: 'Mississauga', state: 'ON', lat: 43.589, lng: -79.6441 },
  { area_code: '367', city: 'Quebec City', state: 'QC', lat: 46.8139, lng: -71.208 },
  { area_code: '368', city: 'Calgary', state: 'AB', lat: 51.0447, lng: -114.0719 },
  { area_code: '403', city: 'Calgary', state: 'AB', lat: 51.0447, lng: -114.0719 },
  { area_code: '416', city: 'Toronto', state: 'ON', lat: 43.6532, lng: -79.3832 },
  { area_code: '418', city: 'Quebec City', state: 'QC', lat: 46.8139, lng: -71.208 },
  { area_code: '428', city: 'Moncton', state: 'NB', lat: 46.0878, lng: -64.7782 },
  { area_code: '431', city: 'Winnipeg', state: 'MB', lat: 49.8951, lng: -97.1384 },
  { area_code: '437', city: 'Toronto', state: 'ON', lat: 43.6532, lng: -79.3832 },
  { area_code: '438', city: 'Montreal', state: 'QC', lat: 45.5019, lng: -73.5674 },
  { area_code: '450', city: 'Laval', state: 'QC', lat: 45.6066, lng: -73.7124 },
  { area_code: '474', city: 'Saskatoon', state: 'SK', lat: 52.1579, lng: -106.6702 },
  { area_code: '506', city: 'Moncton', state: 'NB', lat: 46.0878, lng: -64.7782 },
  { area_code: '514', city: 'Montreal', state: 'QC', lat: 45.5019, lng: -73.5674 },
  { area_code: '519', city: 'London', state: 'ON', lat: 42.9849, lng: -81.2453 },
  { area_code: '548', city: 'London', state: 'ON', lat: 42.9849, lng: -81.2453 },
  { area_code: '579', city: 'Laval', state: 'QC', lat: 45.6066, lng: -73.7124 },
  { area_code: '581', city: 'Quebec City', state: 'QC', lat: 46.8139, lng: -71.208 },
  { area_code: '584', city: 'Winnipeg', state: 'MB', lat: 49.8951, lng: -97.1384 },
  { area_code: '587', city: 'Calgary', state: 'AB', lat: 51.0447, lng: -114.0719 },
  { area_code: '604', city: 'Vancouver', state: 'BC', lat: 49.2827, lng: -123.1207 },
  { area_code: '613', city: 'Ottawa', state: 'ON', lat: 45.4215, lng: -75.6972 },
  { area_code: '639', city: 'Saskatoon', state: 'SK', lat: 52.1579, lng: -106.6702 },
  { area_code: '647', city: 'Toronto', state: 'ON', lat: 43.6532, lng: -79.3832 },
  { area_code: '672', city: 'Vancouver', state: 'BC', lat: 49.2827, lng: -123.1207 },
  { area_code: '705', city: 'Sudbury', state: 'ON', lat: 46.4917, lng: -80.993 },
  { area_code: '709', city: "St. John's", state: 'NL', lat: 47.5615, lng: -52.7126 },
  { area_code: '778', city: 'Vancouver', state: 'BC', lat: 49.2827, lng: -123.1207 },
  { area_code: '780', city: 'Edmonton', state: 'AB', lat: 53.5461, lng: -113.4938 },
  { area_code: '782', city: 'Halifax', state: 'NS', lat: 44.6488, lng: -63.5752 },
  { area_code: '807', city: 'Thunder Bay', state: 'ON', lat: 48.3809, lng: -89.2477 },
  { area_code: '819', city: 'Gatineau', state: 'QC', lat: 45.4765, lng: -75.7013 },
  { area_code: '825', city: 'Calgary', state: 'AB', lat: 51.0447, lng: -114.0719 },
  { area_code: '867', city: 'Whitehorse', state: 'YT', lat: 60.7212, lng: -135.0568 },
  { area_code: '873', city: 'Gatineau', state: 'QC', lat: 45.4765, lng: -75.7013 },
  { area_code: '879', city: "St. John's", state: 'NL', lat: 47.5615, lng: -52.7126 },
  { area_code: '902', city: 'Halifax', state: 'NS', lat: 44.6488, lng: -63.5752 },
  { area_code: '905', city: 'Mississauga', state: 'ON', lat: 43.589, lng: -79.6441 }
]
